// extracted by mini-css-extract-plugin
export default {"container":"header_container__-R+Oe","app":"header_app__4+EYn","name":"header_name__+86dv"};